document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

const STORAGE_KEY = 'newsletter_popup_dismissed';
  const DISMISS_DAYS = 14;
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
      if (dismissedAt && (Date.now() - parseInt(dismissedAt, 10)) < DISMISS_DAYS * 86400000) return;

  let timer;

  const show = () => {
    const d = localStorage.getItem(STORAGE_KEY);
          if (d && (Date.now() - parseInt(d, 10)) < DISMISS_DAYS * 86400000) return;
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const dismiss = () => {
    clearTimeout(timer);
    popup.hidden = true;
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  };

  timer = setTimeout(show, parseInt(popup.dataset.delay || '5', 10) * 1000);

  if (popup.dataset.exitIntent === 'true') {
    document.addEventListener('mouseleave', (e) => {
      if (e.clientY < 10) show();
    });
  }

  popup.querySelector('.newsletter-popup-close').addEventListener('click', dismiss);
  popup.querySelector('.newsletter-popup-dismiss-btn').addEventListener('click', dismiss);

  popup.addEventListener('click', (e) => {
    if (e.target === popup) dismiss();
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#newsletter-popup')) {
    localStorage.removeItem('newsletter_popup_dismissed');
    location.reload();
  }
});